import BaseAPI from '../base.js';
export default {
  login(username,password){
    return BaseAPI.Post("users/login",{
      user: username,
      pass: password
    })
  }
}